<div class="flex align-items-center gap-2">
    <p-select
        [options]="languages()"
        [(ngModel)]="localizeLanguage"
        [filter]="false"
        [style]="{ width: '200px' }"
        filterBy="name"
        optionLabel="name"
        inputId="form-localization" />
    <info-button info="Localization Language, Some fields may be required to be filled in multiple languages." />
</div>
